import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.promise";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";
// Dish Tech React
import { isEqualJson, validators as inbuiltValidators } from '@dishtech-react/utils'; // Action Types

import { actionTypes } from '../action-types'; // Actions

import { registerService } from '../actions/service-actions';

var validateFormField = function validateFormField(dispatch, _ref, nextState, _ref2) {
  var formKey = _ref.formKey,
      fieldName = _ref.fieldName;
  var formConfig = _ref2.formConfig;
  var _formConfig$formKey = formConfig[formKey];
  _formConfig$formKey = _formConfig$formKey === void 0 ? {} : _formConfig$formKey;
  var _formConfig$formKey$f = _formConfig$formKey.fields;
  _formConfig$formKey$f = _formConfig$formKey$f === void 0 ? {} : _formConfig$formKey$f;
  var _formConfig$formKey$f2 = _formConfig$formKey$f[fieldName];
  _formConfig$formKey$f2 = _formConfig$formKey$f2 === void 0 ? {} : _formConfig$formKey$f2;
  var validators = _formConfig$formKey$f2.validators;
  var _nextState$form$formK = nextState.form[formKey];
  _nextState$form$formK = _nextState$form$formK === void 0 ? {} : _nextState$form$formK;
  var _nextState$form$formK2 = _nextState$form$formK.fieldErrors;
  _nextState$form$formK2 = _nextState$form$formK2 === void 0 ? {} : _nextState$form$formK2;
  var _nextState$form$formK3 = _nextState$form$formK2[fieldName],
      fieldErrors = _nextState$form$formK3 === void 0 ? [] : _nextState$form$formK3,
      values = _nextState$form$formK.values,
      _nextState$form$formK4 = _nextState$form$formK.values;
  _nextState$form$formK4 = _nextState$form$formK4 === void 0 ? {} : _nextState$form$formK4;
  var value = _nextState$form$formK4[fieldName];
  var newFieldErrors = [];

  if (validators && validators.length) {
    validators.forEach(function (validator) {
      var fieldError = typeof validator === 'function' ? validator(value, values) : inbuiltValidators[validator](value, values);

      if (fieldError) {
        newFieldErrors.push(fieldError);
      }
    });

    if (newFieldErrors.length && (!fieldErrors.length || !isEqualJson(fieldErrors, newFieldErrors))) {
      return Promise.resolve(dispatch({
        error: true,
        payload: {
          fieldName: fieldName,
          formKey: formKey,
          errors: newFieldErrors
        },
        type: actionTypes.FORM_SET_FIELD_ERRORS
      }));
    } else if (!newFieldErrors.length && fieldErrors.length) {
      return Promise.resolve(dispatch({
        payload: {
          fieldName: fieldName,
          formKey: formKey
        },
        type: actionTypes.FORM_CLEAR_FIELD_ERRORS
      }));
    }
  }
};

var validateAllFormFields = function validateAllFormFields(dispatch, _ref3, nextState, config) {
  var formKey = _ref3.formKey;
  var _config$formConfig$fo = config.formConfig[formKey];
  _config$formConfig$fo = _config$formConfig$fo === void 0 ? {} : _config$formConfig$fo;
  var _config$formConfig$fo2 = _config$formConfig$fo.fields,
      fields = _config$formConfig$fo2 === void 0 ? {} : _config$formConfig$fo2;
  Object.keys(fields).forEach(function (fieldName) {
    return validateFormField(dispatch, {
      formKey: formKey,
      fieldName: fieldName
    }, nextState, config);
  });
};

var fetchChildren = function fetchChildren(dispatch, _ref4, _ref5) {
  var formKey = _ref4.formKey;
  var serviceConfig = _ref5.serviceConfig;
  var _serviceConfig$formKe = serviceConfig[formKey];
  _serviceConfig$formKe = _serviceConfig$formKe === void 0 ? {} : _serviceConfig$formKe;
  var _serviceConfig$formKe2 = _serviceConfig$formKe.childServiceKeys,
      childServiceKeys = _serviceConfig$formKe2 === void 0 ? [] : _serviceConfig$formKe2;
  var results = childServiceKeys.map(function (key) {
    return dispatch(registerService(key));
  });
  return Promise.all(results);
};

var handleRegister = function handleRegister(dispatch, payload, nextState, config) {
  validateAllFormFields(dispatch, payload, nextState, config);
  fetchChildren(dispatch, payload, config);
};

export var getFormMiddleware = function getFormMiddleware(config) {
  return function (store) {
    return function (next) {
      return function (action) {
        var _actions;

        var dispatch = store.dispatch,
            getState = store.getState;
        next(action);
        var nextState = getState();
        var actions = (_actions = {}, _actions[actionTypes.FORM_SET_FIELD_VALUE] = function () {
          return validateFormField(dispatch, action.payload, nextState, config);
        }, _actions[actionTypes.FORM_SET_FIELD_VALUES] = function () {
          return validateAllFormFields(dispatch, action.payload, nextState, config);
        }, _actions[actionTypes.FORM_REGISTER] = function () {
          return handleRegister(dispatch, action.payload, nextState, config);
        }, _actions);

        if (actions[action.type]) {
          return actions[action.type]();
        }
      };
    };
  };
};